import React from 'react';
import "../../css/slider.css";

const mainLandMark = (props) => (
    <div className="slider-container2">
    </div>
    );

export default mainLandMark;